import { useContext } from "react"

import { TLOContext } from "web/contexts"
import { useWorkflow } from "web/hooks/data"

const taskIncomplete = (task) => !task.completer_id

export default function useCurrentStageIncompleteTasks() {
  const { data: deal } = useContext(TLOContext)
  const workflow = useWorkflow(deal.workflow_id)

  const dealIsActive = !("outcome" in deal)

  const hasWorkflow =
    dealIsActive && workflow !== undefined && workflow !== null

  if (!hasWorkflow) {
    return {
      tasks: [],
      workflow,
    }
  }

  const outsideStageIncompleteTasks = workflow.tasks_by_category.reduce(
    (acc, category) => {
      return [...acc, ...category.tasks.filter(taskIncomplete)]
    },
    []
  )

  const incompleteStages = workflow.stages.filter(
    (stage) => !stage.completer_id
  )
  const currentStage = incompleteStages.length > 0 ? incompleteStages[0] : null

  const currentStageIncompleteTasks = currentStage
    ? currentStage.tasks_by_category.reduce((acc, category) => {
        return [...acc, ...category.tasks.filter(taskIncomplete)]
      }, [])
    : []

  return {
    tasks: [...currentStageIncompleteTasks, ...outsideStageIncompleteTasks],
    workflow,
  }
}
